import Modal from 'react-bootstrap/Modal';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';

const RequestOrderCancellationModal = ({ showRequestOrderCancellationModal, handleCloseRequestOrderCancellationModal, handleConfirmRequestOrderCancellationButton }) => {
    /**
     * setup the initial values & validation
     */
    const initialValues = {
        cancellationReason: '',
    };

    const validationSchema = Yup.object().shape({
        cancellationReason: Yup.string()
            .required('Required'),
    });

    return (
        <Modal
            backdrop="static"
            show={showRequestOrderCancellationModal}
            onHide={handleCloseRequestOrderCancellationModal}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Cancel all selected orders?</Modal.Title>
            </Modal.Header>

            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleConfirmRequestOrderCancellationButton}
            >
            {({ errors, dirty, isValid, touched, values }) => (
                <Form>
                    <Modal.Body>
                        <p>Why are you requesting to cancel this order? (Cancellation fee may apply.)</p>
                        <Field as="textarea" rows="5" id="cancellationReason" name="cancellationReason" />
                    </Modal.Body>

                    <Modal.Footer>
                        <button className="button tertiary" type="submit" disabled={!((dirty) && isValid)}>Confirm Cancellation</button>
                    </Modal.Footer>
                </Form>
            )}
            </Formik>
        </Modal>
    );
};

export default RequestOrderCancellationModal;